import { Action } from '../../../shared/xs/actions';

export class FetchProfileAction implements Action {
  static readonly type = '[Profile] Fetch profile';
}
